import { render, staticRenderFns } from "./InspeccionBotiquin.vue?vue&type=template&id=432e2cfc&"
import script from "./InspeccionBotiquin.vue?vue&type=script&lang=js&"
export * from "./InspeccionBotiquin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports